export var Order;
(function (Order) {
    Order[Order["Descending"] = -1] = "Descending";
    Order[Order["Ascending"] = 1] = "Ascending";
    Order[Order["Preserve"] = 0] = "Preserve";
    Order[Order["Ltn"] = -1] = "Ltn";
    Order[Order["Gtn"] = 1] = "Gtn";
    Order[Order["Eql"] = 0] = "Eql";
})(Order || (Order = {}));
export function toOrder(o) {
    if (typeof o === 'number') {
        return o < 0 ? -1 : o > 0 ? 1 : 0;
    }
    if (typeof o === 'string') {
        switch (o.toLowerCase()) {
            case 'descending':
            case 'desc':
            case 'd': {
                return -1;
            }
            case 'ascending':
            case 'asc':
            case 'a': {
                return 1;
            }
        }
    }
    return 0;
}
